import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import loadash from 'lodash';
// import {bindActionCreators} from "redux";
// import {connect} from 'react-redux';
// import * as globalActions from '../../modules/global';

class Error extends Component {
    constructor (props) {
        super (props);
        this.state ={
            message:'The video may not have a video ID or the video may be inactive.'
        };

        this.state.environment = process.env.REACT_APP_NOT_SECRET_CODE;

        if(!loadash.isEmpty(props.error.message))
            this.state.message = props.error.message; 
    }

    componentWillUnmount() {
        // const {
        //     GlobalActions
        // } = this.props;

        // GlobalActions.resetErrorStatus();
    }

    render() {
        const { t, i18n } = this.props;

        return(
            <div id='sharedVideoDetail' className="popup-contents" >
                <div className="popup-empty">
                        {this.state.environment === 'atomy' ? 
                        <div className="visual">
                            <img src={`${process.env.PUBLIC_URL}/images/empty_sharedvideo_atomy.jpg`} alt=""/>
                        </div>
                        :
                        <React.Fragment>
                            <div className="visual">
                                <img src={`${process.env.PUBLIC_URL}/images/empty_sharedvideo.png`} alt=""/>
                            </div>
                            <div className="contents">
                                <strong>The video cannot be verified.</strong>
                                <p>{this.state.message}<br/>Please check and try again.</p>
                            </div>
                        </React.Fragment>                            
                        }
                </div>
            </div>
        )
    }
}

// const mapStateToProps = (state) => {
//     return {
//         global: state.global
//     }
// };

// const mapDispatchToProps = (dispatch) => {
//     return {
//         GlobalActions: bindActionCreators(globalActions, dispatch)
//     };
// };

// Error = connect(mapStateToProps, mapDispatchToProps)(Error);
export default withTranslation()(Error);